/* =============================================================
 * import
 * ========================================================== */

/* =============================================================
 * export function
 * ========================================================== */
export function routeCommonBefore(data) { // eslint-disable-line @typescript-eslint/no-unused-vars
  // 次ページの用意が整った段階
  // 遷移前ページデータ：data.current
  // 遷移後ページデータ：data.next
  // console.log(data);
}


export function routeCommonAfter(data) { // eslint-disable-line @typescript-eslint/no-unused-vars
  // 次ページの用意が整った段階
  // 遷移後ページデータ：data.next
  // console.log(data);
}
